const storageKey = 'dearore-wishlist-v1';

function getWishlist() {
  try { return new Set(JSON.parse(window.localStorage.getItem(storageKey) || '[]')); } catch { return new Set(); }
}

function saveWishlist(items) { window.localStorage.setItem(storageKey, JSON.stringify([...items])); }

function syncFavorites() {
  const wishlist = getWishlist();
  document.querySelectorAll('[data-dearore-favorite]').forEach((button) => {
    const saved = wishlist.has(button.dataset.productId);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', `${saved ? '取消收藏' : '加入收藏'} ${button.dataset.productTitle || ''}`.trim());
  });
}

function startCountdowns() {
  document.querySelectorAll('[data-dearore-sale-end]').forEach((bar) => {
    const target = Date.parse(bar.dataset.dearoreSaleEnd);
    const output = bar.querySelector('[data-dearore-countdown]');
    if (!output || Number.isNaN(target)) return;
    const tick = () => {
      const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
      const days = Math.floor(seconds / 86400);
      const hours = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      const remaining = String(seconds % 60).padStart(2, '0');
      output.textContent = seconds ? `${days}D ${hours}H ${minutes}M ${remaining}S` : (bar.dataset.dearoreEndedLabel || 'FINAL HOURS ENDED');
    };
    tick();
    window.setInterval(tick, 1000);
  });
}

function attachVideoPreviews() {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  document.querySelectorAll('[data-dearore-video-card], .card-gallery').forEach((card) => {
    const video = card.querySelector('video');
    if (!video) return;
    card.addEventListener('pointerenter', () => video.play().catch(() => undefined));
    card.addEventListener('pointerleave', () => { video.pause(); video.currentTime = 0; });
  });
}

function initializeDearOre() { syncFavorites(); startCountdowns(); attachVideoPreviews(); }

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-dearore-favorite]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const wishlist = getWishlist();
  wishlist.has(button.dataset.productId) ? wishlist.delete(button.dataset.productId) : wishlist.add(button.dataset.productId);
  saveWishlist(wishlist);
  syncFavorites();
});
document.addEventListener('DOMContentLoaded', initializeDearOre);
document.addEventListener('shopify:section:load', initializeDearOre);
